import type { CodingAgentState } from '@/features/electron-api/features/CodingAgentsAPI';

import type { SetupProgress } from './coding-agents.store';

/** One line on how far the agent is set up, for its row when no setup step is under way */
export const agentStatusText = (agent: CodingAgentState): string => {
  switch (agent.setup) {
    case 'not-installed':
      return 'Not installed on this Mac';
    case 'signed-out':
      return 'Not signed in';
    case 'installed':
    case 'signed-in':
      return agent.connected ? 'Connected' : 'Ready to connect';
  }
};

/**
 * The switch shows once the agent is ready to connect: installed, signed in or with a sign-in its CLI cannot
 * report, and no setup step under way. An agent that is connected keeps it, so it can always be disconnected
 */
export const showsConnectSwitch = (
  agent: CodingAgentState,
  progress: SetupProgress | undefined
): boolean =>
  agent.connected ||
  (!progress && (agent.setup === 'signed-in' || agent.setup === 'installed'));
